import React from 'react'
import moment from 'moment'

const LogTable = ({ logs }) => {
  return (
    <table className="table log-table">
      <thead>
        <tr>
          <td>Browser/Device</td>
          <td>Location</td>
          <td>Recent Activity</td>
        </tr>
      </thead>
      <tbody>
        {logs.map((item, index) => {
          const city = item.location_info.city_name ? item.location_info.city_name+',':''
          return (
            <tr key={index}>
              <td>{item.user_agent}</td>
              <td>{`${city} ${item.location_info.country_name && item.location_info.country_name}`}</td>
              <td>
                Time:{moment(item.date).format('MMMM Do [at] h:mm')}
                <br />IP:{item.ip}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default LogTable



// WEBPACK FOOTER //
// src/components/ProfileSettings/LogTable.js